import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import WalkinSection from './WalkinSection';

export default function WalkinVisitSection({ form, selectedSession, docName }) {
  const { bookingMode, setBookingMode, slot, setSlot, symptoms, setSymptoms } = form;

  return (
    <WalkinSection
      step={3}
      title="Today's visit"
      hint="Walk-ins join the doctor queue after triage. Optional slot if they arrived for a timed window."
      testId="walkin-visit-section"
    >
      {selectedSession ? (
        <div className="rounded-xl border border-[#D5DEE8] bg-[#F8FAFC] px-3 py-2.5 text-[12px] text-[#071B34]">
          <span className="font-semibold">{docName(selectedSession.doctor_id)}</span>
          <span className="text-[#5A6B7C]"> · {selectedSession.start_time}–{selectedSession.end_time}</span>
          <span className="text-[#5A6B7C]"> · Fee base ₹{selectedSession.consultation_fee || 0}</span>
        </div>
      ) : (
        <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2">
          Select an open session on the left before registering.
        </p>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Visit type</Label>
          <Select value={bookingMode} onValueChange={setBookingMode}>
            <SelectTrigger data-testid="rec-mode"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="walkin">Walk-in (queue after triage)</SelectItem>
              <SelectItem value="slot">Preferred time slot</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {bookingMode === 'slot' && (
          <div className="space-y-1.5">
            <Label>Preferred time (HH:MM)</Label>
            <Input value={slot} onChange={(e) => setSlot(e.target.value)} placeholder="09:30" data-testid="rec-slot" />
          </div>
        )}
      </div>
      <div className="space-y-1.5">
        <Label>Chief complaint / reason for visit</Label>
        <Textarea
          rows={3}
          value={symptoms}
          onChange={(e) => setSymptoms(e.target.value)}
          placeholder="e.g. Fever since 2 days, sore throat — helps triage & the doctor"
          className="resize-none text-sm"
          data-testid="rec-symptoms"
        />
        <p className="text-[10px] text-[#5A6B7C]">Optional now — you can refine this during triage.</p>
      </div>
    </WalkinSection>
  );
}
